// extracted by mini-css-extract-plugin
module.exports = {"section":"styles__section--2jB4-"};